import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotInbox"*/ './lazyIndex'),
    { name: 'CopilotInbox' }
);

export const lazyCopilotInboxProcessorForSelectedRows: LazyAction<
    typeof lazyIndex.copilotInboxProcessorForSelectedRows,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.copilotInboxProcessorForSelectedRows);

export const lazyFetchCopilotInboxHeadline: LazyAction<
    typeof lazyIndex.fetchCopilotInboxHeadline,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchCopilotInboxHeadline);

export const lazyProcessFolderForPrioritization: LazyAction<
    typeof lazyIndex.processFolderForPrioritization,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.processFolderForPrioritization);

export const lazyCreatePrioritizationReport: LazyAction<
    typeof lazyIndex.analyzeFolderPrioritizationData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.analyzeFolderPrioritizationData);

export const lazyCreatePrioritizationReportDraft: LazyAction<
    typeof lazyIndex.createPrioritizationReportDraft,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createPrioritizationReportDraft);

export const lazyShowPrioritizationRunNamingDialog: LazyAction<
    typeof lazyIndex.showPrioritizationRunNamingDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showPrioritizationRunNamingDialog);

// Export types
export type { PrioritizationResult } from './services/inboxPrioritizationCategoryService';

// Export actions (non-lazy)
export { prioritizeExperimentalLabellingAction } from './actions/prioritizeExperimentalLabellingAction';
